import * as React from 'react';

import { CodeTabsContext } from './CodeTabs';
import { Toolbar } from './Toolbar';
import './Code.styles.scss';

interface CodeProps extends React.HTMLAttributes<HTMLPreElement> {
  'data-language': string;
  'data-theme'?: string;
}

/**
 * Custom code block component that includes a 'Copy' button, the code block language,
 * and syntax highlighting.
 */
export const Code = (props: CodeProps) => {
  const context = React.useContext(CodeTabsContext);
  const isInCodeTabs = context?.isInCodeTabs || false;

  return (
    <>
      {!isInCodeTabs && <Toolbar language={props['data-language']} />}
      <div className="code-block">
        <pre {...props} />
      </div>
    </>
  );
};
